import React from "react";
import { Stack } from "@chakra-ui/react";
import { useStudentPlan } from "../../../hooks/use-student-plan";
import { PackageSelection } from "./PackageSelection";

export const StudentPackagePlan: React.FC = () => {
  const { checkout } = useStudentPlan();
  return (
    <Stack spacing={8} p={{ base: 0, sm: 4 }} w={["full", "90%"]} mx="auto">
      <PackageSelection onCheckout={checkout} />
    </Stack>
  );
};
